import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["form-steps"]
  static targets = ["form"]

  connect() {
  }

  submit(event) {
    let outletValid;
    if (this.hasFormStepsOutlet) {
      outletValid =  this.formStepsOutlet.validateCurrentStep();
    } else {
      outletValid = true;
    }
    if (!this.hasFormTarget) {
      outletValid ? this.showOverlay() : nil;

      return;
    }
    const targetValid = this.formTarget.checkValidity();
    if (!(outletValid && targetValid)) {
      return;
    }
    this.showOverlay();
  }

  showOverlay() {
    document.getElementById('page-overlay').style.display = 'flex';
  }
}
